import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { getStore } from '@/util/store';
import { ref } from 'vue';
import AnalysisDialog from 'hxhy-analysis-dialog';
import sendTrack from './sendTrack';
export default {
  __name: 'AiQuestionStem',
  props: {
    content: {
      type: Object,
      default: function _default() {}
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var show = ref(false);
    var query = ref({
      text: '',
      userId: ''
    });
    // 去除标签
    var stripHtmlTags = function stripHtmlTags(item) {
      var parser = new DOMParser();
      var dom = parser.parseFromString(item, 'text/html');
      return dom.body.textContent || '';
    };

    // 提取题干部分并且拼接在一起
    var _extractContent = function extractContent(data) {
      var contents = [];
      // 如果为题型1、2，3、4、6，提取它们的题干
      if (['SINGLE_CHOICE', 'MULTIPLE_CHOICE', 'COMPLETION', 'ANSWER_QUESTIONS', 'JUDGE'].includes(data.type)) {
        contents.push(stripHtmlTags(data.content));
      }

      // 如果题目类型为5且包含子题，递归处理子题
      if (data.type === 'COMPREHENSIVE' && data.childs && data.childs.length > 0) {
        contents.push(stripHtmlTags(data.content));
        data.childs.forEach(function (child) {
          contents.push.apply(contents, _toConsumableArray(_extractContent(child)));
        });
      }

      // 如果题目类型为1或2并存在选项，提取选项
      if (['SINGLE_CHOICE', 'MULTIPLE_CHOICE'].includes(data.type) && data.options && data.options.length > 0) {
        var optionsContent = data.options.map(function (option) {
          return option.code + option.content;
        });
        contents.push.apply(contents, _toConsumableArray(optionsContent.map(function (content) {
          return stripHtmlTags(content);
        })));
      }
      return contents.join('');
    };

    // 打开AI解析弹窗
    var openParsing = function openParsing() {
      sendTrack('AI_CreativeCenter_Practice_AIAnalysis');
      var token = getStore({
        name: 'access_token'
      });
      query.value = {
        token: token,
        text: _extractContent(props.content)
      };
      show.value = true;
    };
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
        class: "ai-button",
        onClick: openParsing
      }, [_createVNode(_component_svg_icon, {
        class: "ai-tips",
        name: "ai-tips",
        size: "16"
      }), _cache[1] || (_cache[1] = _createElementVNode("span", {
        class: "ai-button_text"
      }, "AI解析", -1))]), _createVNode(_unref(AnalysisDialog), {
        modelValue: show.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return show.value = $event;
        }),
        question: query.value.text,
        token: query.value.token,
        typingEffect: false
      }, null, 8, ["modelValue", "question", "token"])]);
    };
  }
};